// Generated by CoffeeScript 2.7.0
var PostForm;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import RichTextEditor from 'trunks/vue/admin/components/libs/richtext_editor.js';

import FormableMixin from 'trunks/vue/admin/compositions/formables/mixin.js';

import {
  newMessageSettingsModal
} from 'trunks/vue/admin/compositions/message_settings.js';

export default PostForm = Vue.extend({
  mixins: [FormableMixin],
  components: {
    editor: RichTextEditor
  },
  props: {
    resource: {
      type: String,
      default: '/admin/posts'
    },
    type: {
      type: String,
      default: 'post'
    }
  },
  data: function() {
    return {
      post: {
        title: '消息标题',
        html_body: '',
        published_as_id: null,
        namecard_id: null
      }
    };
  },
  template: `<div class="formable-edit-view">
  <div class="formable-base-content">
    <div class="formable-title">
      <input type="text" placeholder='消息标题' v-model.trim='post.title' />
    </div>
    <div class="formable-description">
      <editor ref='editor' :value='post.html_body' placeholder='消息正文' scrollingContainer='main>.main-content' @valueChanged='editorTextChange' />
    </div>
  </div>
  <div class="attachments-container" v-show='attachments.length'>
    <attachments :files='attachments'
                 @removeItem='removeAttachment'
                 @reloadItem='reloadAttachment' />
  </div>
  <div class="formable-actions" ref='formableActions'>
    <div class="slp-tooltip right" data-title="添加附件">
      <label class="action-item clickable">
        <input type="file" multiple='true' hidden='true' @change='addAttachments' />
        <i class="slp-attachment"></i>
      </label>
    </div>
  </div>
</div>`,
  methods: {
    getData: function() {
      return {
        post: this.post
      };
    },
    preview: function() {
      return Skylark.Libs.Ajax['post']('/admin/posts/preview_version', {
        data: this.getData(),
        contentType: "application/json; charset=UTF-8",
        success: function(data, status, xhr) {
          return window.open(Skylark.Helpers.UrlHelper.namespaceUrlFor(`messages/preview?key=${data.key}`));
        },
        error: function(xhr, status) {
          return newAlertify('预览失败', {
            type: 'error'
          });
        }
      });
    },
    openSaveConfirm: function() {
      var settings_modal;
      settings_modal = newMessageSettingsModal(this.post);
      return settings_modal.$on('ensureClicked', (settings) => {
        var save_xhr;
        this.updatePostSettings(settings);
        save_xhr = this.save();
        if (!save_xhr) {
          return newAlertify('发布失败', {
            type: 'error',
            description: '请检查网络连接'
          });
        }
      });
    },
    updatePostSettings: function(settings) {
      var post_settings;
      post_settings = _.reduce(settings, function(memo, value, key) {
        var ref, ref1;
        switch (key) {
          case 'pushSetting':
            memo.user_boundary_attributes = value.user_boundary;
            memo.push_agent_on_publish_attributes = {
              include_uncompleted: true,
              push_package_id: (ref = value.push_agent) != null ? ref.push_package_id : void 0,
              scheduled_at: (ref1 = value.push_agent) != null ? ref1.scheduled_at : void 0
            };
            break;
          case 'tagsNamecardSetting':
            memo.tag_ids = value.tag_ids;
            break;
          case 'releaseSetting':
            memo.published_as_id = value.organization_id;
            memo.namecard_id = value.namecard_id;
            break;
          case 'commentSetting':
            _.extend(memo, value);
        }
        return memo;
      }, {});
      return _.extend(this.post, post_settings);
    },
    editorTextChange: function(value) {
      return this.post.html_body = value;
    }
  }
});
